module.exports = __webpack_public_path__ + "static/tat11-bbf263424efb52382e57f47a6ba5a78d.jpg";